$(document).ready(function () {

    function disable_scroll_mobile() {
        window.addEventListener('touchmove', wheel, { passive: false });
    }
    function enable_scroll_mobile() {
        window.removeEventListener('touchmove', wheel, { passive: false });
    }
    // var keys = [32, 33, 34, 35, 36, 37, 38, 39, 40];
    var keys = [33, 34, 35, 36, 38, 40];
    function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault)
            e.preventDefault();
        e.returnValue = false;
    }
    function keydown(e) {
        for (var i = keys.length; i--;) {
            if (e.keyCode === keys[i]) {
                preventDefault(e);
                return;
            }
        }
    }
    function wheel(e) {
        preventDefault(e);
    }
    function disable_scroll() {
        if (window.addEventListener) {
            window.addEventListener('DOMMouseScroll', wheel);
        }
        window.addEventListener('mousewheel', wheel, { passive: false });
        document.onkeydown = keydown;
        disable_scroll_mobile();
    }
    function enable_scroll() {
        if (window.removeEventListener) {
            window.removeEventListener('DOMMouseScroll', wheel);
        }
        window.removeEventListener('mousewheel', wheel, { passive: true });
        enable_scroll_mobile();
    }

    /*** iOS Body Scroll Lock with open menu/other modal blocks ***/

    var $docEl = $('body'),
        scrollTop;
    var overlayClose = function () {
        $.unlockBody();
    }
    var overlayOpen = function () {
        $.lockBody();
    }
    $.lockBody = function () {
        if (window.pageYOffset) {
            scrollTop = window.pageYOffset;
        }
        $docEl.css({
            height: "100%",
            overflow: "hidden"
        });
        $('html').css({
            height: "100%",
            overflow: "hidden"
        });
    }
    $.unlockBody = function () {
        $docEl.css({
            height: "",
            overflow: ""
        });
        $('html').css({
            height: "",
            overflow: ""
        });
        window.scrollTo(0, scrollTop);
        window.setTimeout(function () {
            scrollTop = null;
        }, 0);
    }

    var $btnOpen = $('.filter-btn'),
        $closeFilter = $('.overlay_page, .filter-block .close, .filter-block .cancel-btn'),
        $showMenuEl = $('.filter-block'),
        $btnOpenP = $('.project-filter-btn'),
        $closeFilterP = $('.overlay_page, .project-filter-block .close, .project-filter-block .cancel-btn'),
        $showMenuElP = $('.project-filter-block'),
        $btnOpenA = $('.article-filter-btn'),
        $closeFilterA = $('.overlay_page, .article-filter-block .close, .article-filter-block .cancel-btn'),
        $showMenuElA = $('.article-filter-block');

    $btnOpen.on('click', function (e) {
        e.preventDefault();
        $showMenuEl.addClass('open');
        $('.overlay_page').fadeIn(200);

        if (window.innerWidth < 1092) {
            overlayOpen();
        } else {
            //disable_scroll();
            $('body').addClass('no-scroll');
        }

        $('.save-fliter-btn').on('click', function() {
            $showMenuEl.removeClass('open');
            $('body').removeClass('no-scroll');
        });
    });

    $closeFilter.on('click', function () {
        $showMenuEl.removeClass('open');
        $('body').removeClass('no-scroll');
        if($('#beforeDeletingArticle').css('display') !== 'block') {
            $('.overlay_page').fadeOut(200);
        }

        if (window.innerWidth < 1092) {
            overlayClose();
        } else {
            enable_scroll();
        }
    });
    $showMenuEl.on('click', '.show-more-filters', function() {
        $(this).prev('.more-filters').slideToggle();
        $(this).toggleClass('show');
    });

    $btnOpenP.on('click', function (e) {
        e.preventDefault();
        $showMenuElP.addClass('open');
        $('.overlay_page').fadeIn(200);

        if (window.innerWidth < 1092) {
            overlayOpen();
        } else {
            disable_scroll();
        }

        $('.save-fliter-btn').on('click', function() {
            $showMenuElP.removeClass('open');
        });


        if($(window).width() > 1024) {
            $('.custom_scrollbar_y').mCustomScrollbar({
                theme: "minimal-dark",
                autoHideScrollbar: false,
                scrollInertia: 0
            });
        }
    });

    $closeFilterP.on('click', function () {
        $showMenuElP.removeClass('open');
        if($('#beforeDeletingArticle').css('display') !== 'block') {
            $('.overlay_page').fadeOut(200);
        }

        if (window.innerWidth < 1092) {
            overlayClose();
        } else {
            enable_scroll();
        }
    });
    $showMenuElP.on('click', '.show-more-filters', function() {
        $(this).prev('.more-filters').slideToggle();
        $(this).toggleClass('show');
    });

    $btnOpenA.on('click', function (e) {
        e.preventDefault();
        $showMenuElA.addClass('open');
        $('.overlay_page').fadeIn(200);

        if (window.innerWidth < 1092) {
            overlayOpen();
        } else {
            disable_scroll();
        }

        $('.save-fliter-btn').on('click', function() {
            $showMenuElA.removeClass('open');
        });

        if($(window).width() > 1024) {
            $('.custom_scrollbar_y').mCustomScrollbar({
                theme: "minimal-dark",
                autoHideScrollbar: false,
                scrollInertia: 0
            });
        }
    });

    $closeFilterA.on('click', function () {
        $showMenuElA.removeClass('open');
        if($('#beforeDeletingArticle').css('display') !== 'block') {
            $('.overlay_page').fadeOut(200);
        }

        if (window.innerWidth < 1092) {
            overlayClose();
        } else {
            enable_scroll();
        }
    });
    $showMenuElA.on('click', '.show-more-filters', function() {
        $(this).prev('.more-filters').slideToggle();
        $(this).toggleClass('show');
    });

    $('.js-filter-country ul li').on('click', function () {
        var id = $(this).attr('data-id');
        var url = $('.js-filter-country').attr('data-action');
        var self = this;
        $('.js-filter-country').find('input[name=country]').val(id);

        $('.selected_filter_list ul').find('li:not(.country-item)').each(function(){
            $(this).find('.icon-close').trigger('click');
        });

        var req = $.ajax({
            method: 'post',
            url: url,
            data: {'country_id': id, '_token': CSRF_TOKEN},
        });
        req.done(function (resp) {
            if (resp.success) {
                $('.js-filter-regions').find('.js-regions-list').remove();
                if (resp.count) {
                    $('.js-filter-regions').removeClass('disabled');
                } else {
                    $('.js-filter-regions').addClass('disabled');
                }
                if (resp.html) {
                    $('.js-filter-regions').append(resp.html);
                }
                var selectedRegions = JSON.parse($('.js-filter-regions').attr('data-selected'));
                if (selectedRegions) {
                    for (var i = 0; i < selectedRegions.length; i++) {
                        $('.js-filter-regions input:checkbox[value="' + selectedRegions[i] + '"]').click();
                    }
                    getFilterCities();
                }

                if($(window).width() > 1024) {
                    $('.custom_scrollbar_y').mCustomScrollbar({
                        theme: "minimal-dark",
                    });
                }
                onFilterboxSelectChange($(this));
            }
        });
    });

    function getFilterCities(){
    // $('.js-filter-regions').on('click', 'input:checkbox', function () {
        var country_id = $('.js-filter-country').find('input[name=country]').val();
        var region_ids = $('.js-filter-regions').find('input:checked').map(function(i, el){
            return $(el).val();
        }).get();
        var url = $('.js-filter-regions').attr('data-action');
        var req = $.ajax({
            method: 'post',
            url: url,
            data: {'region_ids': region_ids, 'country_id': country_id, '_token': CSRF_TOKEN},
        });
        req.done(function (resp) {
            if (resp.success) {
                $('.js-filter-cities').find('.js-cities-list').remove();
                var allCitiesText =  $('.js-filter-cities').attr('data-allcheck');
                var nothingFoundText = $('.js-filter-cities').attr('data-nothing');
                var placeholderText = $('.js-filter-cities').attr('data-placeholder');
                var data;

                var div_dd = document.createElement('div');
                div_dd.classList = 'drop_down-list js-cities-list';

                var div_scrollbar = document.createElement('div');
                div_scrollbar.classList = 'custom_scrollbar_y';

                div_dd.appendChild(div_scrollbar);

                var p_empty = document.createElement('p');
                p_empty.classList = 'empty';
                p_empty.style.display = 'none';
                p_empty.textContent = nothingFoundText;

                div_scrollbar.appendChild(p_empty);

                var div_fg = document.createElement('div');
                div_fg.classList = 'form-group search-group';
                div_fg.innerHTML = '<input type="text" class="search_box" placeholder="' + placeholderText + '"><i class="icon-search"></i>';

                div_dd.prepend(div_fg);

                var ul = document.createElement('ul');

                ul.innerHTML = '<li class="allcities checkbox-group"><label><input type="checkbox" class="allcheck" data-value="default" id="cities_all" name="cities[]" value="" >' + allCitiesText + '</label></li>';


                for (var region in resp.cities) {
                  data = resp.cities[region];

                  for (var i in data) {
                    var input = document.createElement('input');
                    var label = document.createElement('label');
                    var li = document.createElement('li');
                    li.classList = 'checkbox-group';
                    input.type = "checkbox";
                    input.value = i;
                    input.name = 'cities[]';
                    input.id = 'region'+[region]+'city'+[i];
                    label.textContent = data[i];
                    label.appendChild(input);
                    li.appendChild(label);
                    ul.appendChild(li);
                  }

                }

                div_scrollbar.appendChild(ul);

                $('.js-filter-cities').append(div_dd);
                if (resp.count) {
                    $('.js-filter-cities').removeClass('disabled');
                }
                if (resp.html) {
                    $('.js-filter-cities').append(resp.html);
                }
                var selectedCities = JSON.parse($('.js-filter-cities').attr('data-selected'));
                if (selectedCities) {
                    for (var i = 0; i < selectedCities.length; i++) {
                        $('.js-filter-cities input:checkbox[value="' + selectedCities[i] + '"]').click();
                    }
                }
                
                if($(window).width() > 1024) {
                    $('.custom_scrollbar_y').mCustomScrollbar({
                        theme: "minimal-dark",
                        autoHideScrollbar: false,
                        scrollInertia: 0
                    });
                }
              }
          });

    // });
    }
    
    var $regionDropDown = $(".js-filter-regions");
    $regionDropDown.find(' > .select').on('click', function () {
        if($regionDropDown.hasClass('changed') && $regionDropDown.hasClass('regions-closed') && $regionDropDown.find('input:checked').length > 0) {
            getFilterCities();
            $regionDropDown.removeClass('changed');
            $regionDropDown.removeClass('regions-closed');
        }
    });
    $(document).on('mouseup', function (e) {
        if ($regionDropDown.has(e.target).length === 0 && !$('.icon-close').is(e.target)) {
            if($regionDropDown.hasClass('changed') && $regionDropDown.hasClass('regions-closed') && $regionDropDown.find('input:checked').length > 0) {
              if($regionDropDown.find('input:checked').length == 1 && !$('#region_all:checked').length){
                getFilterCities();
              } else {
                $('.js-filter-cities').addClass('disabled');
              }
              $regionDropDown.removeClass('changed');
              $regionDropDown.removeClass('regions-closed');
            }
        }
    });
    
    if ($('.js-filter-country ul li[selected]').length) {
        $('.js-filter-country ul li[selected]').click();
    }
    if ($('.js-filter-country ul li.active').length) {
        $('.js-filter-country ul li.active').click();
    }
    $('#saveFilter form').on('submit', function () {
        if ($(this).find('input[name=title]').val().trim()) {
            var url = $(this).attr('data-action');
            var data = $('.js-filter-block').find('input').serialize();
            data += '&'+$(this).serialize();
            var req = $.ajax({
                method: 'post',
                url: url,
                data: data,
            });
            req.done(function (resp) {
                if (resp.success) {
                    $('#saveFilter').find('.close').trigger('click');
                    if (resp.href) {
                        location.href = resp.href;
                    } else {
                        location.reload();
                    }
                }
            });
        }
    });
    $('.js-filter-block a.confirm-btn').on('click', function () {
        var data = $('.js-filter-block').find('form').submit();
    });
    $('.js-filter-block .js-save-filter-btn').on('click', function () {
        if ($('.js-filter-block').find('input[name=title]').val().trim()) {
            var url = $('.js-filter-block').attr('data-action');
            var data = $('.js-filter-block').find('input').serialize();
            data += '&_token='+CSRF_TOKEN;
            var req = $.ajax({
                method: 'post',
                url: url,
                data: data,
            });
            req.done(function (resp) {
                if (resp.success) {
                    if (resp.href) {
                        location.href = resp.href;
                    } else {
                        location.reload();
                    }
                }
            });
        }
    });
    $('body').on('click', 'a[data-popup=deleteFilter]', function () {
        var id = $(this).attr('data-id');
        $('#deleteFilter').find('input[name=id]').val(id);
    });
    $('body').on('click', '#deleteFilter .confirm-btn', function () {
        var id = $('#deleteFilter').find('input[name=id]').val();
        var url = $('#deleteFilter').attr('data-action');
        var req = $.ajax({
            method: 'post',
            url: url,
            data: {'id': id, '_token': CSRF_TOKEN},
        });
        req.done(function (resp) {
            if (resp.success) {
                location.reload();
            }
        });
    });

    $('.js-project-filter-block a.confirm-btn').on('click', function () {
        var data = $('.js-project-filter-block').find('input').serialize();
        var url = document.location.href.substring(0, document.location.href.indexOf('?'));
        url += '?' + data;
        document.location = url;
    });
    $('.js-article-filter-block a.confirm-btn').on('click', function () {
        var data = $('.js-article-filter-block').find('input').serialize();
        var url = document.location.href.substring(0, document.location.href.indexOf('?'));
        url += '?' + data;
        document.location = url;
    });


    // select on filterbox 111 data-sels


    var onFilterboxSelectChange = function($this){
        var select = $this.closest('.selectholder');
        if(select.hasClass('region-select')) {
            var regionsText = select.attr('data-regions');
            select.addClass('changed');
            $('.selected_filter_list').find('li.cities').find('.icon-close').trigger('click');
        }
        if(select.hasClass('city-select')) {
            var citiesText = select.attr('data-cities');
        }

        if ( $this.is(':checked') ) {
            $this.closest('.drop_down-list ul').find('input.allcheck').closest('li').removeClass('checked');
            $this.closest('li').addClass('checked');

            if($this.closest('.selectholder').siblings('.selected_filter_list').length) {
                $this.closest('.selectholder').siblings('.selected_filter_list').find('ul').append('<li class="' + $this.attr('name').split('[')[0] + '" data-id="' + $this.attr('id') + '">' + $this.closest('label').text() + ' <i class="icon-close s-8"></i></li>');
            } else {
                $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="' + $this.attr('name').split('[')[0] + '" data-id="' + $this.attr('id') + '">' + $this.closest('label').text() + ' <i class="icon-close s-8"></i></li>');
            }

            if(select.hasClass('region-select')) {
                if ( $this.hasClass('allcheck')) {
                    select.find('.drop_down-list ul input:checked:not(.allcheck)').each(function() {
                        $(this).prop('checked', false);
                        $('.selected_filter_list ul').find('[data-id="' + $(this).attr('id') + '"]').find('.icon-close').trigger('click');
                    });
                    select.find('li').removeClass('checked');
                    $this.closest('li').addClass('checked');
                    select.find('input.allcheck').prop('checked', true);
                } else {
                    select.find('.drop_down-list ul input.allcheck:checked').prop('checked', false);
                    $('.selected_filter_list ul').find('[data-id="region_all"]').remove();
                }
            }
            
            if(select.hasClass('city-select')) {
                if ( $this.hasClass('allcheck')) {
                    select.find('.drop_down-list ul input:not(.allcheck)').each(function() {
                        $(this).prop('checked', true);
                        $(this).closest('li').addClass('checked');
                        // $('.selected_filter_list ul').find('[data-id="' + $(this).attr('id') + '"]').find('.icon-close').trigger('click');
                    });
                    $this.closest('li').addClass('checked');
                    select.find('input.allcheck').prop('checked', true);
                } else {
                    // select.find('.drop_down-list ul input.allcheck:checked').prop('checked', false);
                    // $('.selected_filter_list ul').find('[data-id="region_all"]').remove();
                }
            }

        } else {
            $this.closest('li').removeClass('checked');
            $('.selected_filter_list ul').find('[data-id="' + $this.attr('id') + '"]').find('.icon-close').trigger('click');
            if(select.hasClass('city-select')) {
                select.find('.drop_down-list ul input.allcheck').prop('checked', false);
                select.find('li.allcities').removeClass('checked');
                $('.selected_filter_list ul').find('[data-id="cities_all"]').remove();
            }
        }

        if ( select.find('.drop_down-list ul input:checked').length ) {
            if (select.find('.drop_down-list ul input:checked').length > 1) {
                select.find('.current').text(select.find('.current').attr('data-sels')+' (' + select.find('.drop_down-list ul input:not(.allcheck):checked').length + ')' );

                if(select.hasClass('region-select')) {
                    if($this.closest('.filters-container').length) {
                        $this.closest('.filters-container').find('.selected_filter_list.filter_row ul .regions').remove();
                        $this.closest('.filters-container').find('.selected_filter_list.filter_row ul').append('<li class="regions" data-id="regions">' + regionsText + ' ' + select.find('.drop_down-list ul input:not(.allcheck):checked').length + ' <i class="icon-close s-8"></i></li>');
                    }
                    if($this.closest('.region-site-select').length) {
                        $this.closest('.region-site-select').parent().find('.selected_filter_list ul .regions').remove();
                        $this.closest('.region-site-select').parent().find('.selected_filter_list ul').append('<li class="regions" data-id="regions">' + regionsText + ' ' + select.find('.drop_down-list ul input:not(.allcheck):checked').length + ' <i class="icon-close s-8"></i></li>');
                    } 
                }
                if(select.hasClass('city-select')) {
                    if($this.closest('.filters-container').length) {
                        $this.closest('.filters-container').find('.selected_filter_list.filter_row ul .cities').remove();
                        $this.closest('.filters-container').find('.selected_filter_list.filter_row ul').append('<li class="cities" data-id="cities">' + citiesText + ' ' + select.find('.drop_down-list ul input:not(.allcheck):checked').length + ' <i class="icon-close s-8"></i></li>');
                    } 
                    if($this.closest('.city-site-select').length) {
                        $this.closest('.selectholder').siblings('.selected_filter_list').find('ul .cities').remove();
                        $this.closest('.selectholder').siblings('.selected_filter_list').find('ul').append('<li class="cities" data-id="cities">' + citiesText + ' ' + select.find('.drop_down-list ul input:not(.allcheck):checked').length + ' <i class="icon-close s-8"></i></li>');
                    }
                }

            } else {
                if(select.hasClass('region-select')) {
                    if($this.closest('.filters-container').length) {
                        $this.closest('.filters-container').find('.selected_filter_list.filter_row ul .regions').remove();
                        $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="' + select.find('.drop_down-list ul input:checked').attr('name').split('[')[0] + '" data-id="' + select.find('.drop_down-list ul input:checked').attr('id') + '">' + select.find('.drop_down-list ul input:checked').closest('label').text() + ' <i class="icon-close s-8"></i></li>');
                    } 
                    if($this.closest('.region-site-select').length) {
                        $this.closest('.region-site-select').parent().find('.selected_filter_list ul .regions').remove();
                        $this.closest('.region-site-select').siblings('.selected_filter_list').find('ul').append('<li class="' + select.find('.drop_down-list ul input:checked').attr('name').split('[')[0] + '" data-id="' + select.find('.drop_down-list ul input:checked').attr('id') + '">' + select.find('.drop_down-list ul input:checked').closest('label').text() + ' <i class="icon-close s-8"></i></li>');
                    } 
                }
                if(select.hasClass('city-select')) {
                    if($this.closest('.filters-container').length) {
                        $this.closest('.filters-container').find('.selected_filter_list').find('ul .cities').remove();
                        $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="' + select.find('.drop_down-list ul input:checked').attr('name').split('[')[0] + '" data-id="' + select.find('.drop_down-list ul input:checked').attr('id') + '">' + select.find('.drop_down-list ul input:checked').closest('label').text() + ' <i class="icon-close s-8"></i></li>');
                    }
                    if($this.closest('.city-site-select').length) {
                        $this.closest('.selectholder').siblings('.selected_filter_list').find('ul .cities').remove();
                        $this.closest('.selectholder').siblings('.selected_filter_list').find('ul').append('<li class="' + select.find('.drop_down-list ul input:checked').attr('name').split('[')[0] + '" data-id="' + select.find('.drop_down-list ul input:checked').attr('id') + '">' + select.find('.drop_down-list ul input:checked').closest('label').text() + ' <i class="icon-close s-8"></i></li>');
                    }
                }
                if ( select.find('input.allcheck:checked').length ) {
                    select.find('.current').text(select.find('.current').attr('data-all'));
                } else {
                    select.find('.current').text( select.find('.drop_down-list ul input:checked').parent('label').text() );
                }
            }
        } else {
            select.find('.current').text(select.find('.current').attr('data-placeholder'));
            if(select.hasClass('region-select')) {
                $('.city-select input:checked, .js-site-cities input:checked').each(function() {
                    $(this).prop('checked', false);
                    $(this).closest('li').removeClass('checked');
                });
                $('.selected_filter_list').find('li.cities').find('.icon-close').trigger('click');
                $('.city-select, .js-site-cities').addClass('disabled');
                $('.city-select, .js-site-cities').find('.current').text($('.city-select, .js-site-cities').find('.current').attr('data-placeholder'));
            }
        }
        if ($('.filters-container .selected_filter_list').find('li').length) {
            $('.filters-container .selected_filter_list').show();
        } else {
            $('.filters-container .selected_filter_list').hide();
        }
    };
    $('.selectholder').on('click', 'input:checkbox', function() {
        onFilterboxSelectChange($(this));
    });
    $('.selectholder input:checkbox:not(.allcheck)').each(function() {
        onFilterboxSelectChange($(this));
    });

    // range on filterbox
    var onFilterRangeInputChange = function($this){
      let $thisParentInput = $this.closest('.price-item');
      var priceMin = $this.attr("data-price-min"),
      priceMax = $this.attr("data-price-max"),
      valMin = $thisParentInput.find('.price_input:first-child input').val(),
      valMax = $thisParentInput.find('.price_input:last-child input').val(),
      flag = false;

      if($this.closest('.filters-container').length) {
        if($this.data('id') == 'trust-range' && $this.closest('.filter_row').siblings('.selected_filter_list').find('.trust-range').length){
          flag = true;
        } 
        if(!flag && $this.data('id') == 'sqi-range' && $this.closest('.filter_row').siblings('.selected_filter_list').find('.sqi-range').length) {
          flag = true;
        } 
        if(!flag && $this.data('id') == 'traffic-range' && $this.closest('.filter_row').siblings('.selected_filter_list').find('.traffic-range').length){
          flag = true;
        }
      }
      if(valMin == priceMin && valMax != priceMax) {
        if(flag){
          $this.closest('.filter_row').siblings('.selected_filter_list').find('.'+$this.data('id')).html($this.data('to') + ' '+ valMax + ($this.data('id') == 'traffic-range' ?  ' ' + $this.data('val'): '') + ' <i class="icon-close s-8"></i></li>');
        } else {
          $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="'+$this.data('id')+'" data-id="' + $this.data('id') + '">' + $this.data('to') + ' '+ valMax + ($this.data('id') == 'traffic-range' ?  ' ' + $this.data('val'): '') + '<i class="icon-close s-8"></i></li>');
        }
      } else if(valMin != priceMin && valMax == priceMax) {
        if(flag){
          $this.closest('.filter_row').siblings('.selected_filter_list').find('.'+$this.data('id')).html($this.data('from') + ' '+ valMin + ($this.data('id') == 'traffic-range' ?  ' ' + $this.data('val'): '') + ' <i class="icon-close s-8"></i></li>');
        } else {
          $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="'+$this.data('id')+'" data-id="' + $this.data('id') + '">' +   $this.data('from') + ' '+ valMin + ($this.data('id') == 'traffic-range' ?  ' ' + $this.data('val'): '') + ' <i class="icon-close s-8"></i></li>');
        }
      } else if (valMin != priceMin && valMax != priceMax) {
        if(flag){
          $this.closest('.filter_row').siblings('.selected_filter_list').find('.'+$this.data('id')).html($this.data('from') + ' ' + valMin + ' ' + $this.data('from-to') + ' ' + valMax + ($this.data('id') == 'traffic-range' ?  ' ' + $this.data('val'): '') + ' <i class="icon-close s-8"></i></li>');
        } else {
          $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="'+$this.data('id')+'" data-id="' + $this.data('id') + '">' + $this.data('from') + ' ' + valMin + ' ' + $this.data('from-to') + ' ' + valMax + ($this.data('id') == 'traffic-range' ?  ' ' + $this.data('val'): '') + ' <i class="icon-close s-8"></i></li>');
        }
      } else {
        if($this.data('id') == 'trust-range'){
          $this.closest('.filter_row').siblings('.selected_filter_list').find('.trust-range').remove();
        } 
        if ($this.data('id') == 'sqi-range'){
          $this.closest('.filter_row').siblings('.selected_filter_list').find('.sqi-range').remove();
        } 
        if ($this.data('id') == 'traffic-range'){
          $this.closest('.filter_row').siblings('.selected_filter_list').find('.traffic-range').remove();
        }
      }
      flag = false; 
    };
  // price load
    var onFilterboxPriceLoad = function(){
      if($('.filters-container').length){
        var $filterPriceStart = $('#price_from').val(),
            $filterPriceEnd = $('#price_to').val(),
            $filterFromTxt = $('#price_from').closest('.price_input').data('from'),
            $filterToTxt = $('#price_from').closest('.price_input').data('to'),
            $filterCurrency = $('#price_from').closest('.price_input').data('currency');
        if($filterPriceStart > 0 && $filterPriceEnd == 0 ){
          $('#price_from').closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="btn-price-item" data-id="price">' +  $filterFromTxt + ' ' + $filterPriceStart + ' ' + $filterCurrency + ' <i class="icon-close s-8"></i></li>');
        } else if ( $filterPriceStart == 0 && $filterPriceEnd > 0){
          $('#price_from').closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="btn-price-item" data-id="price">' +  $filterToTxt + ' ' + $filterPriceEnd + ' ' + $filterCurrency + ' <i class="icon-close s-8"></i></li>');
        } else if ( $filterPriceStart > 0 && $filterPriceEnd > 0){
          $('#price_from').closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="btn-price-item" data-id="price">' +  $filterFromTxt + ' ' + $filterPriceStart + ' ' + $filterCurrency + ' ' + $filterPriceEnd + ' ' +  $filterCurrency + '<i class="icon-close s-8"></i></li>');
        }
      }
    };
    onFilterboxPriceLoad();
	// select on filterbox
    var onFilterboxCheckboxChange = function($this){
        if($this.closest('.checkbox-group').length) {
            if ( $this.is(':checked') ) {
                if($this.closest('.selectholder').siblings('.selected_filter_list').length) {
                    $this.closest('.selectholder').siblings('.selected_filter_list').find('ul').append('<li class="' + $this.attr('name').split('[')[0] + '" data-id="' + $this.attr('id') + '">' + $this.siblings('label').text() + ' <i class="icon-close s-8"></i></li>');
                } else {
                    $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="' + $this.attr('name').split('[')[0] + '" data-id="' + $this.attr('id') + '">' + $this.siblings('label').text() + ' <i class="icon-close s-8"></i></li>');
                }

            } else {
                $('.selected_filter_list ul').find('[data-id="' + $this.attr('id') + '"]').remove();
                // $('.selected_filter_list.filter_row ul').find('.regions').remove();
            }
        }
        else if($this.hasClass('btn-price')) {
            if(!$this.hasClass('active')) {
                $('.selected_filter_list ul').find('[data-id="' + $this.closest('.price-btns').find('.active').attr('id') + '"]').remove();
                if(!$('.selected_filter_list ul').find('[data-id="' + $this.closest('.price-btns').find('.active').attr('id') + '"]').length){
                  $('.selected_filter_list ul .btn-price-item').remove();
                }
                $this.closest('.price-btns').find('.active').removeClass('active');

                $this.addClass('active');
                $this.closest('.filter_row').find('.price_input #price_from').val($this.find('.from-number').text());
                $this.closest('.filter_row').find('.price_input #price_to').val($this.find('.to-number').text());

                if($this.closest('.selectholder').siblings('.selected_filter_list').length) {
                    if($this.find('.to-number').length) {
                        $this.closest('.selectholder').siblings('.selected_filter_list').find('ul').append('<li class="btn-price-item" data-id="' + $this.attr('id') + '">' + 'От ' + $this.find('.from-number').text() + ' USD до ' + $this.find('.to-number').text() + ' USD' + ' <i class="icon-close s-8"></i></li>');
                    } else {
                        $this.closest('.selectholder').siblings('.selected_filter_list').find('ul').append('<li class="btn-price-item" data-id="' + $this.attr('id') + '">' + 'От ' + $this.find('.from-number').text() + ' USD' + ' <i class="icon-close s-8"></i></li>');
                    }
                } else {
                    if($this.find('.to-number').length) {
                        $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="btn-price-item" data-id="' + $this.attr('id') + '">' + 'От ' + $this.find('.from-number').text() + ' USD до ' + $this.find('.to-number').text() + ' USD' + ' <i class="icon-close s-8"></i></li>');
                    } else {
                        $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="btn-price-item" data-id="' + $this.attr('id') + '">' + 'От ' + $this.find('.from-number').text() + ' USD' + ' <i class="icon-close s-8"></i></li>');
                    }
                }
            }
        } else if($this.hasClass('btn-custom-price')) {
            $('.selected_filter_list ul').find('.btn-price-item').remove();
            $('.price-btns').find('.active').removeClass('active');

            var from = $this.closest('.filter_row').find('.price_input #price_from').val();
            var to = $this.closest('.filter_row').find('.price_input #price_to').val();
            if($this.closest('.selectholder').siblings('.selected_filter_list').length) {
                if (from) {
                    if (to) {
                        $this.closest('.selectholder').siblings('.selected_filter_list').find('ul').append('<li class="btn-price-item" data-id="' + $this.attr('id') + '">' + 'От ' + from + ' USD до ' + to + ' USD' + ' <i class="icon-close s-8"></i></li>');
                    } else {
                        $this.closest('.selectholder').siblings('.selected_filter_list').find('ul').append('<li class="btn-price-item" data-id="' + $this.attr('id') + '">' + 'От ' + from + ' USD' + ' <i class="icon-close s-8"></i></li>');
                    }
                } else if (to) {
                    $this.closest('.selectholder').siblings('.selected_filter_list').find('ul').append('<li class="btn-price-item" data-id="' + $this.attr('id') + '">' + 'До ' + to + ' USD' + ' <i class="icon-close s-8"></i></li>');
                }
            } else {
                if (from) {
                    if (to) {
                        $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="btn-price-item" data-id="' + $this.attr('id') + '">' + 'От ' + from + ' USD до ' + to + ' USD' + ' <i class="icon-close s-8"></i></li>');
                    } else {
                        $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="btn-price-item" data-id="' + $this.attr('id') + '">' + 'От ' + from + ' USD' + ' <i class="icon-close s-8"></i></li>');
                    }
                } else if (to) {
                    $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="btn-price-item" data-id="' + $this.attr('id') + '">' + 'До ' + to + ' USD' + ' <i class="icon-close s-8"></i></li>');
                }
            }
        } else if($this.hasClass('js-filter-name')) {
            $('.selected_filter_list ul').find('.btn-name-item').remove();

            var name = $this.val();
            if($this.closest('.selectholder').siblings('.selected_filter_list').length) {
                if (name) {
                    $this.closest('.selectholder').siblings('.selected_filter_list').find('ul').append('<li class="btn-name-item" data-id="' + $this.attr('id') + '">' + name + ' <i class="icon-close s-8"></i></li>');
                }
            } else {
                if (name) {
                    $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="btn-name-item" data-id="' + $this.attr('id') + '">' + name + ' <i class="icon-close s-8"></i></li>');
                }
            }
        } else if($this.hasClass('js-filter-trust')) {
            $('.selected_filter_list ul').find('.btn-trust_from-item').remove();

            var value = $this.val();
            var text = $this.attr('data-text') + value;
            if($this.closest('.selectholder').siblings('.selected_filter_list').length) {
                if (value) {
                    $this.closest('.selectholder').siblings('.selected_filter_list').find('ul').append('<li class="btn-trust_from-item" data-id="' + $this.attr('id') + '">' + text + ' <i class="icon-close s-8"></i></li>');
                }
            } else {
                if (value) {
                    $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="btn-trust_from-item" data-id="' + $this.attr('id') + '">' + text + ' <i class="icon-close s-8"></i></li>');
                }
            }
        } else if($this.hasClass('js-filter-sqi')) {
            $('.selected_filter_list ul').find('.btn-sqi_from-item').remove();

            var value = $this.val();
            var text = $this.attr('data-text') + value;
            if($this.closest('.selectholder').siblings('.selected_filter_list').length) {
                if (value) {
                    $this.closest('.selectholder').siblings('.selected_filter_list').find('ul').append('<li class="btn-sqi_from-item" data-id="' + $this.attr('id') + '">' + text + ' <i class="icon-close s-8"></i></li>');
                }
            } else {
                if (value) {
                    $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="btn-sqi_from-item" data-id="' + $this.attr('id') + '">' + text + ' <i class="icon-close s-8"></i></li>');
                }
            }
        } else if($this.hasClass('js-filter-traffic')) {
            $('.selected_filter_list ul').find('.btn-traffic_from-item').remove();

            var value = $this.val();
            var text = $this.attr('data-text') + value;
            if($this.closest('.selectholder').siblings('.selected_filter_list').length) {
                if (value) {
                    $this.closest('.selectholder').siblings('.selected_filter_list').find('ul').append('<li class="btn-traffic_from-item" data-id="' + $this.attr('id') + '">' + text + ' <i class="icon-close s-8"></i></li>');
                }
            } else {
                if (value) {
                    $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li class="btn-traffic_from-item" data-id="' + $this.attr('id') + '">' + text + ' <i class="icon-close s-8"></i></li>');
                }
            }
        }
        if ($('.filters-container .selected_filter_list').find('li').length) {
            $('.filters-container .selected_filter_list').show();
        } else {
            $('.filters-container .selected_filter_list').hide();
        }
    };
    $('.filter-block .filter_row .checkbox-group').on('click', 'input:checkbox', function() {
        onFilterboxCheckboxChange($(this));
    });
    $('.filter-block .filter_row .checkbox-group input:checkbox').each(function() {
        onFilterboxCheckboxChange($(this));
    });
    $('.js-filter-name, .js-filter-trust, .js-filter-sqi, .js-filter-traffic').each(function() {
        onFilterboxCheckboxChange($(this));
    });

    $('.filter-block .price-btns').on('click', '.btn-price', function() {
        onFilterboxCheckboxChange($(this));
    });

    $('.btn-custom-price').on('click', function() {
        onFilterboxCheckboxChange($(this));
    });
    $('.btn-custom-price').click();
    $('.js-filter-name, .js-filter-trust, .js-filter-sqi, .js-filter-traffic').on('keyup', function() {
        onFilterboxCheckboxChange($(this));
    });
    $('.filter-block .price-btns .btn-price').each(function() {
        //onFilterboxCheckboxChange($(this));
    });

    $('.selected_filter_list').on('click', '.icon-close', function() {
        $('#' + $(this).closest('li').attr('data-id')).prop('checked', false);
        $('#' + $(this).closest('li').attr('data-id')).closest('li').removeClass('checked');
        if($(this).closest('li').hasClass('btn-name-item')) {
            $('.js-filter-name').val('');
        }
        if($(this).closest('li').hasClass('btn-trust_from-item')) {
            $('.js-filter-trust').val('');
        }
        if($(this).closest('li').hasClass('btn-sqi_from-item')) {
            $('.js-filter-sqi').val('');
        }
        if($(this).closest('li').hasClass('btn-traffic_from-item')) {
            $('.js-filter-traffic').val('');
        }
        $(this).closest('li').remove();
        onFilterboxSelectChange($('#' + $(this).closest('li').attr('data-id')));
        onFilterboxCheckboxChange($('#' + $(this).closest('li').attr('data-id')));

        if ($(this).closest('li').attr('data-id').indexOf('country') !== -1) {
            $('#' + $(this).closest('li').attr('data-id')).closest('.drop_down').find('li.active').removeClass('active');
            $('#' + $(this).closest('li').attr('data-id')).closest('.drop_down').find('.select span').text($('#' + $(this).closest('li').attr('data-id')).closest('.drop_down').find('.select span').attr('data-placeholder'));
            $('.js-filter-country').find('input[name=country]').val('');
            $('.city-select, .js-site-cities, .region-select').addClass('disabled');

            $('.city-select input:checked, .js-site-cities input:checked').each(function() {
                $(this).prop('checked', false);
                $(this).closest('li').removeClass('checked');
            });
            $('.selected_filter_list').find('li.cities').remove();
            $('.city-select, .js-site-cities').find('.current').text($('.city-select, .js-site-cities').find('.current').attr('data-placeholder'));

            $('.region-select input:checked').each(function() {
                $(this).prop('checked', false);
                $(this).closest('li').removeClass('checked');
            });
            $('.selected_filter_list').find('li.regions').remove();
            $('.region-select').find('.current').text($('.region-select').find('.current').attr('data-placeholder'));
        }
        if ($(this).closest('li').hasClass('trust-range')) {
          ReserSlider($(".slider-range[data-id='trust-range']"));
        }
        if ($(this).closest('li').hasClass('traffic-range')) {
          ReserSlider($(".slider-range[data-id='traffic-range']"));
        }
        if ($(this).closest('li').hasClass('sqi-range')) {
          ReserSlider($(".slider-range[data-id='sqi-range']"));
        }
        if ($(this).closest('li').hasClass('regions')) {
            let $this = $(this);
            //TODO multiple closing regions
            $('.city-select input:checked, .js-site-cities input:checked').each(function() {
                $(this).prop('checked', false);
                $(this).closest('li').removeClass('checked');
            });
            $('.selected_filter_list').find('li.cities').remove();
            $('.city-select, .js-site-cities').find('.current').text($('.city-select, .js-site-cities').find('.current').attr('data-placeholder'));

            $('.js-filter-regions input:checked').each(function() {
                $(this).prop('checked', false);
                $(this).closest('li').removeClass('checked');
            });
            $('.selected_filter_list.filter_row').find('li.regions').remove();
            $('.js-filter-regions').find('.current').text($('.region-select').find('.current').attr('data-placeholder'));
            // $('.city-select, .js-site-cities').addClass('disabled');
            //
            // $('.city-select input:checked, .js-site-cities input:checked').each(function() {
            //     if($(this).attr('id').indexOf($this.closest('li').attr('data-id')) !== -1) {
            //         $(this).prop('checked', false);
            //         $(this).closest('li').removeClass('checked');
            //         onFilterboxSelectChange($(this));
            //     }
            // });
            // $('.selected_filter_list').find('li.cities').each(function() {
            //     if($(this).attr('data-id').indexOf($this.closest('li').attr('data-id')) !== -1) {
            //         $(this).remove();
            //     }
            // });
            $('.js-filter-cities').find('.js-cities-list').remove();
            $('.city-select').addClass('disabled');
            if(!$('.js-site-regions input:checked').length){
                $('.js-site-cities').find('.js-cities-list').remove();
                $('.js-site-cities').addClass('disabled');
            }
        }

        if ($(this).closest('li').hasClass('cities')) {
            $('.city-select input:checked').each(function() {
                $(this).prop('checked', false);
                $(this).closest('li').removeClass('checked');
            });
            $('.selected_filter_list.filter_row').find('li.cities').remove();
            $('.city-select').find('.current').text($('.city-select').find('.current').attr('data-placeholder'));
        }

        if($(this).closest('li').hasClass('btn-price-item')) {
            if($('#' + $(this).closest('li').attr('data-id')).hasClass('active')) {
                $('#' + $(this).closest('li').attr('data-id')).removeClass('active');
            }
            $('.price_input #price_from').val('');
            $('.price_input #price_to').val('');
        }

    });

    $('.js-catalog-filter-list li .js-catalog-filter-list-close').on('click', function () {
        var field = $(this).attr('data-field');
        var action = $(this).attr('data-action');
        var req = $.ajax({
            method: 'post',
            url: action,
            data: {'field': field, '_token': CSRF_TOKEN},
        });
        req.always(function (resp) {
            location.reload();
        });
    });

    
    $('.prices_wrap').on('input', '.price_input input', function() {
      $('.selected_filter_list ul .btn-price-item').remove();
      onFilterboxPriceLoad();
    });
    /** Validation for price input  **/
    $('.price-item').on('input', '.price_input input', function() {
        let start = this.selectionStart;
        let end = this.selectionEnd;
        
        const current = this.value
        const corrected = current.replace(/([^0-9\.]+)/gi, '');
        this.value = corrected;
        
        if (corrected.length < current.length) --end;
        this.setSelectionRange(start, end);
        var priceMin = $(this).parent().parent().find('.price_input:first-child input');
        var priceMax = $(this).parent().parent().find('.price_input:last-child input');
        var priceFrom = parseFloat(priceMin.val());
        var priceTo = parseFloat(priceMax.val());

        if(priceFrom > priceTo) {
            priceMin.val(parseInt(priceMax.val()) - 1) ;
        } 
        if(priceTo < priceFrom) {
            priceMax.val(parseInt(priceMin.val()) + 1);
        } 

        if(priceMin.val()[0] == 0) {
            priceMin.val(priceMin.val().replace('0', ''));
        }
        if(priceMax.val()[0] == 0) {
            priceMax.val(priceMax.val().replace('0', ''));
        }

        if(priceMax.val().length == 0) {
            priceMax.val('0');
            priceMin.val('0');
        }
        if(priceMin.val().length == 0) {
            priceMin.val('0');
        }

        if(parseFloat(priceMax.val()) > parseFloat(priceMax.attr('max'))) {
            priceMax.val(priceMax.attr('max'));
        }
    });
        
    $('.price-item').on('blur', '.price_input input', function() {  
        let $thisParent = $(this).closest('.price-item');
        if($thisParent.find('.price_input:last-child input').val()[0] == 0) {
            $thisParent.find('.price_input:last-child input').val('1');
        }
    });

    // price range

    var $slider = $(".slider-range");
    $slider.each(function(){
        let $thisContainer = $(this).closest('.price-item');

        //Get min and max values
        var priceMin = $(this).attr("data-price-min"),
            priceMax = $(this).attr("data-price-max");

        //Set min and max values where relevant
        $thisContainer.find(".priceFrom").attr({
            "min": priceMin,
            "max": parseInt(priceMax) - 1
        });
        $thisContainer.find(".priceTo").attr({
            "min": parseInt(priceMin) + 1,
            "max": priceMax
        });
        $thisContainer.find(".priceFrom").attr({
            "placeholder": "min " + priceMin,
            "value": $thisContainer.find(".priceFrom").val() ? $thisContainer.find(".priceFrom").val() : priceMin
        });
        $thisContainer.find(".priceTo").attr({
            "placeholder": "max " + priceMax,
            "value": $thisContainer.find(".priceTo").val() ? $thisContainer.find(".priceTo").val() : priceMax
        });

        $(this).slider({
            range: true,
            min: Math.max(priceMin, 0),
            max: priceMax,
            values: [$thisContainer.find(".priceFrom").val(), $thisContainer.find(".priceTo").val()],
            create: function( event, ui ) {
              onFilterRangeInputChange($(this));
            },
            slide: function(event, ui) {
                $thisContainer.find(".priceFrom").val(ui.values[0]);
                $thisContainer.find(".priceTo").val(ui.values[1]);
                onFilterRangeInputChange($(this));
            }
        });
        function updateSlider($this){
            let $thisContainer = $this.closest('.price-item'),
                $thisSlider = $thisContainer.find('.slider-range');
            $thisSlider.slider("values", [$thisContainer.find(".priceFrom").val(), $thisContainer.find(".priceTo").val()]);
        }
        $(this).on( "slidestop", function() {  
            if( $thisContainer.find('.price_input:last-child input').val()[0] == 0) {
                $thisContainer.find('.price_input:last-child input').val('1');
            }
            if(parseFloat( $thisContainer.find('.price_input:last-child input').val()) == parseFloat( $thisContainer.find('.price_input:first-child input').val())) {
                $thisContainer.find('.price_input:first-child input').val(parseInt( $thisContainer.find('.price_input:last-child input').val()) - 1);
            } 
        });

        $thisContainer.find(".priceFrom, .priceTo").map(function(){
            $(this).on("blur", function() {
                updateSlider($(this));
                
                let $container = $(this).closest('.price-item');
                $container.find('.price_input').each(function() {
                    $(this).find('input').prop('readonly', true);
                });
                onFilterRangeInputChange($container.find('.slider-range'));
            });
        });
    });
    function ReserSlider(param){
      var priceMin = param.attr("data-price-min"),
          priceMax = param.attr("data-price-max");
      param.slider("option", "values", [priceMin, priceMax]);
      //param.remove;
      let $thisContainer = param.closest('.price-item');
      $thisContainer.find(".priceFrom").val(priceMin);
      $thisContainer.find(".priceTo").val(priceMax)
    }

    $('.edit_filter').on('click', function() {
        let $container = $(this).closest('.price-item');
        $container.find('.price_input').each(function() {
            $(this).find('input').prop('readonly', false);
        });
    });

});
